<template>
  <div>
    <b-container>
      <FormulateForm v-model="formValues"
        class="form-wrapper"
        @submit="onSubmit"
        name="calendarForm"
        :invalid-message="invalidMessage"
      > 
        <h2 class="mt-5 mb-4">Calendar Form</h2>
          <FormulateInput
              class="mt-3"
              name="eventGroup"
              type="group"
              :repeatable="this.filledevent ? false : true"
              add-label="+ Additional Event"
              validation-name="event"
              validation="min:1,length"
              #default="{ index }"
          >
            <b-row>
              <b-col md='12 mb-3'>
                <FormulateInput type="text" :value="filledevent ? getDefault(index, 'id') : null" name="id" label="Event ID" disabled/>
              </b-col>
              <b-col md="3">
                  <FormulateInput label="District" type="text" name="district" v-model="user.district" disabled/>
              </b-col>
              <b-col md="3">
                <formulateInput 
                  type="vue-select" 
                  name="eventType"  
                  label="Event Type:"
                  :value="getDefault(index, 'event_type')"
                  :options="eventList"
                  validation='required'
                  placeholder='Select a event type'
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  label="Event Date:"
                  type="date"
                  name="eventDate"
                  :value="getDefault(index, 'event_date')"
                  :validation="[
                      ['^required'],
                  ]"
                />
              </b-col>
              <b-col md="3" class="mt-1" v-if="isERorLS(index)">
                  <formulateInput
                      v-if="formValues.eventGroup[index].eventType === 'ER'"
                      label="Early Release Time"
                      :value="getDefault(index, 'time')"
                      type="time"
                      name="time"
                      validation='required'
                  />
                  <formulateInput
                      v-if="formValues.eventGroup[index].eventType === 'LS'"
                      label="Late Start Time"
                      :value="getDefault(index, 'time')"
                      type="time"
                      name="time" 
                      validation='required'
                  />
              </b-col>
              <b-col md="6">
                <b-row class="ml-1 mb-2 mt-2">Grade Range:</b-row>
                <b-row>
                  <b-col>
                    <FormulateInput
                      type="vue-select"
                      name="lowGrade"
                      :value="getDefault(index, 'low_grade')"
                      placeholder="Low grade"
                      :validation="[
                          ['^required'],
                      ]"
                      :options="gradeList"
                    />
                  </b-col>
                  <b-col>
                    <FormulateInput
                      type="vue-select"
                      name="highGrade"
                      :value="getDefault(index, 'high_grade')"
                      placeholder="High grade"
                      :options="gradeList"
                      :validation="[
                          ['^required'],
                          ['afterLowgrade']
                      ]"
                      :validation-rules="{
                          afterLowgrade: ({ value }) => formValues.eventGroup[index] && Number(value) >= Number(formValues.eventGroup[index].lowGrade),
                      }"
                      :validation-messages="{
                          afterLowgrade:`High grade should be higher than low grade.`,
                      }"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12" class="mt-3">
                  <formulateInput
                      class="mt-2"
                      type="textarea"
                      label="Note"
                      name="notes"
                      :value="getDefault(index, 'notes')"
                      placeholder="Please write any additional information here."
                      validation="max:1024,length"
                  />
              </b-col>
              <b-col md="12" class="mt-2">
                  <formulateInput
                      class="mt-2"
                      type="checkbox"
                      name="buildingOverride"
                      label="Is this event for specific schools or buildings?"
                      :checked="getDefaultOverride(index)"
                  />
              </b-col>
              <b-col md="12" v-if="isBuildingOverride(index)">
                  <v-select class="mt-1" 
                    :options="schoolList" 
                    label="name"
                    v-model="selectedSchools[index]"
                    multiple
                    :reduce="school => school.code"
                    placeholder="Please select a school or program"/>
                  <FormulateInput type="hidden" name="building" v-model="selectedSchools[index]" validation="^required"/>
              </b-col>
            </b-row>
          </FormulateInput>
        <b-row>
            <b-col xs="12" class="text-center mt-3 mb-3">
              <FormulateErrors />
              <FormulateInput
                class="mt-3"
                type="button"
                label="Event List"
                @click="$router.push({
                  name: 'EventList',
                })"
              />
              <FormulateInput
                class="mt-3"
                type="submit"
                label="Submit"
                validation-behavior="live"
                />
            </b-col>
        </b-row>
      </FormulateForm>
      {{ filledevent }} <p></p>
      Endpoint Data: {{ formValues }} 
    </b-container>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import DropdownLists from '../components/DropdownLists.json';
import { postNewCalendarEvent, getBuilding,  getUser } from '../services/api.js';

  export default {
    components: { },
    data() {
      return {
        formValues: {},
        eventList: DropdownLists.eventList,
        gradeList: DropdownLists.gradeList,
        selectedSchools: [],
        schoolList: [],
        user: {},
      }
    },
    props: ["filledevent"],
    methods: {
      async onSubmit () {
        let clonedFormValues = cloneDeep(this.formValues.eventGroup);
        for (let i = 0; i < clonedFormValues.length; i++){
          for (const key of Object.keys(clonedFormValues[i])) {
            // delete clonedFormValues[i]['district']
            const prevLength = Object.keys(clonedFormValues[i]).length
            const camelToSnakeCase = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
            clonedFormValues[i][camelToSnakeCase] = clonedFormValues[i][key]
            clonedFormValues[i].length
            if (Object.keys(clonedFormValues[i]).length > prevLength)
              delete clonedFormValues[i][key]
          }
        }
         try {
          let response = await postNewCalendarEvent(clonedFormValues)
          if (response.status !== 201){
            //  check for response.status
            throw new Error(response.statusText);
          }
          let body = await response.data; // or .json() or whatever
          console.log(body)
          // process body
          alert('All validation complete, form submitted.')
          this.$router.push({
            name: 'EventList',
          })
        } catch (error) {
          alert('Form submission failed!')
          console.log(error)
        }
      },
      invalidMessage(fields) {
        const fieldNames = Object.keys(fields)
        const listOfNames = fieldNames.map(fieldName => fieldName.replace('_', ' '))
        return `Oops! There are some errors above. Invalid fields: ${listOfNames}`
      },
      getDefault(index, key) {
        if (this.filledevent && index == 0) {
          return String(this.filledevent?.[key])
        } else {
          return ''
        }
      },
      getDefaultOverride (index) {
        if (this.filledevent && index == 0) {
          let ret = this.filledevent?.building ? true : false
          if (ret && !this.formValues.eventGroup?.[index]) {
            this.selectedSchools[index] = this.filledevent.building
          }
          return ret
        }
      },
      isERorLS (index) {
        let type = this.formValues?.eventGroup?.[index]?.eventType
        return type === 'ER'||type === 'LS'
      },
      isBuildingOverride (index) {
        let ret = this.formValues?.eventGroup?.[index]?.buildingOverride
        if (ret === undefined) {
          return this.filledevent
        } else {
          if (!ret) {
            this.selectedSchools[index]=[]
          }
          return ret
        }
      },
      updateSelectedSchools() {
        this.selectedSchools = this.formValues.eventGroup.map(group => group.building)
      }
    },
    computed: {

    },
    mounted() {
      getUser()
          .then(result => result.data)
          .then(result => {
              this.user = result
          }, error => {
              console.error(error);
          });
      getBuilding()
          .then(result => result.data)
          .then(result => {
              this.schoolList = result
          }, error => {
              console.error(error);
          });
      

    },
  }
</script>

